<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md6 class="text-xs-center">
        <h2 class="mb-3">Sem permissão</h2>
        <p class="mb-4">Você não tem acesso a esta área.</p>
        <v-btn class="secondary" :to="{ name: 'ImoveisRoot' }">Voltar para Imóveis</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {}
</script>




// WEBPACK FOOTER //
// Forbidden.vue?15981a97